import type { SupabaseClient } from "@supabase/supabase-js";

/**
 * The generated Database types are produced from the platform-managed project,
 * while the app runs against the owner's project (APP_SUPABASE_*). That project
 * has tables, columns and functions the generated file knows nothing about:
 * user_shelves, collections, collection_redirects, person_index, the cached
 * facet/search functions, and the content-safety and quality columns on media.
 *
 * Those calls are correct at runtime. Wrapping the client here widens its types
 * for exactly those calls instead of hand-editing the generated file (which is
 * regenerated by the platform) or turning off the typecheck.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function loose(client: unknown): SupabaseClient<any, "public", any> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return client as SupabaseClient<any, "public", any>;
}
